import React, { useState, useRef } from "react";
import { Typography, Grid, Stack } from "@mui/material";

import { Select, Input } from "../Common";
import InputEmail from "../Common/InputFieldEmail";
import InputMobileNumber from "../Common/InputFieldMobileNumber";

import useFileUpload from "../../hooks/useFileUpload";

import { TranslateW } from "../../Utils/Languages/Translate";
import { trakrefFontFamilySemiBold } from "../../utils";
import Routes from "../../routes";

const UserAddFormUserDetails = ({
    userInfo,
    options,
    onHandleValueChanged,
    isFieldValid,
    isFieldUnique,
    isEditing,
    userId,
    setErrorExist,
}) => {
    const fileInputRef = useRef();
    const [profileImage, setProfileImage] = useState(userInfo.headshot);

    const { readFileDataAsBase64 } = useFileUpload();

    const onUploadFileClick = () => {
        fileInputRef.current.click();
    };

    const onFileChange = async (e) => {
        const file = e.target.files[0];
        const byteFile = await readFileDataAsBase64(file);

        if (isEditing) {
            let formData = new FormData();
            formData.append("fileTypeId", 8);
            formData.append("fileName", file.name);
            formData.append("contentType", file.type);
            formData.append("fileBytes", byteFile);
            formData.append("postedByUserId", userId);

            await fetch(Routes.File.UploadUserFile(), {
                method: "POST",
                body: formData,
            });
        } else {
            onHandleValueChanged("filesTableModel", {
                fileTypeId: 8,
                fileName: file.name,
                contentType: file.type,
                fileBytes: byteFile,
            });
        }

        setProfileImage(URL.createObjectURL(file));
    };

    return (
        <>
            <div className="editprofile-header-container">
                {profileImage ? (
                    <img className="greenImageLarge" src={profileImage} />
                ) : (
                    <div className="greenCircleLarge">{userInfo.shortName}</div>
                )}
                <div>
                    <Typography
                        variant="h5"
                        sx={{
                            "&.MuiTypography-root": {
                                fontFamily: trakrefFontFamilySemiBold,
                                fontSize: "16px",
                            },
                        }}
                        style={{ color: "#333333" }}
                    >
                        {userInfo.name.replace(" ", "").length > 0
                            ? userInfo.name
                            : "Full name"}
                    </Typography>
                    <span className="update-image-label" onClick={onUploadFileClick}>
                        {TranslateW("Profile.UploadProfilePicture")}
                    </span>
                    <input
                        ref={fileInputRef}
                        type="file"
                        style={{ display: "none " }}
                        accept="image/png, image/gif, image/jpeg"
                        onChange={onFileChange}
                    />
                </div>
            </div>

            <Grid container spacing={6} sx={{ marginBottom: "20px" }}>
                <Grid item xs={6} md={6}>
                    <Stack spacing={3}>
                        {
                            isEditing && (
                                <Input
                                    required
                                    fullWidth
                                    disabled
                                    label="Username"
                                    value={userInfo.userName}
                                />
                            )
                        }
                        <Input
                            required
                            fullWidth
                            value={userInfo.firstName}
                            label={TranslateW("Profile.Firstname")}
                            error={isFieldValid(userInfo.firstName)}
                            onChange={(e) =>
                                onHandleValueChanged("firstName", e.target.value)
                            }
                        />
                        <Input
                            required
                            fullWidth
                            value={userInfo.lastName}
                            error={isFieldValid(userInfo.lastName)}
                            label={TranslateW("Profile.Lastname")}
                            onChange={(e) => onHandleValueChanged("lastName", e.target.value)}
                        />
                        <Select
                            value={userInfo.fkid}
                            label={TranslateW("Profile.ContractorDesignation")}
                            options={options.company}
                            onChange={(e) => onHandleValueChanged("fkid", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.title}
                            label={TranslateW("Profile.Title")}
                            onChange={(e) => onHandleValueChanged("title", e.target.value)}
                        />
                        <Input
                            fullWidth
                            value={userInfo.description}
                            label={TranslateW("Profile.Description")}
                            onChange={(e) =>
                                onHandleValueChanged("description", e.target.value)
                            }
                        />
                    </Stack>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Stack spacing={3}>
                        <InputEmail
                            required
                            fullWidth
                            value={userInfo.email}
                            error={isFieldValid(userInfo.email) || isFieldUnique("email")}
                            helperText={isFieldUnique("email") ? isFieldUnique("email") : "This field is required"}
                            label={TranslateW("Profile.EmailAddress")}
                            isValid={(e) => setErrorExist(e)}
                            onChange={(e) => onHandleValueChanged("email", e.target.value)}
                        />
                        <InputMobileNumber
                            fullWidth
                            value={userInfo.cell}
                            label={TranslateW("Profile.MobileNumber")}
                            onChange={(e) => onHandleValueChanged("cell", e.target.value)}
                            isValid={(e) => setErrorExist(e)}
                            getCountryCode={(value) =>
                                onHandleValueChanged("countryCode", value)
                            }
                        />
                        <InputMobileNumber
                            fullWidth
                            value={userInfo.phone}
                            label={TranslateW("Profile.PhoneNumber")}
                            onChange={(e) => onHandleValueChanged("phone", e.target.value)}
                            isValid={(e) => setErrorExist(e)}
                            getCountryCode={(value) =>
                                onHandleValueChanged("countryCode2", value)
                            }
                        />
                        <Input
                            fullWidth
                            value={userInfo.fax}
                            label={TranslateW("Profile.Fax")}
                            onChange={(e) => onHandleValueChanged("fax", e.target.value)}
                        />
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
};

export default UserAddFormUserDetails;
